import * as THREE from 'three';
import { XR_LEFT_AXIS_SWITCH_RATIO, XR_MAX_FRAME_DELTA, XR_MAX_ROTATION_SPEED, XR_MAX_TRAVEL_BOOST, XR_MIN_TRAVEL_MULTIPLIER, XR_ROTATION_SPEED, XR_TRANSLATION_SPEED, XR_VERTICAL_SPEED_SCALE } from '../_data/spaceCanvas.js';
import { applyDeadZone } from './spaceCanvasHelpers.js';
export function resolveXrLeftStickAxis(x, y, previous) {
    const turn = Math.abs(applyDeadZone(x));
    const vertical = Math.abs(applyDeadZone(y));
    if (turn === 0 && vertical === 0)
        return undefined;
    if (previous === 'turn')
        return vertical > turn * XR_LEFT_AXIS_SWITCH_RATIO ? 'vertical' : 'turn';
    if (previous === 'vertical')
        return turn > vertical * XR_LEFT_AXIS_SWITCH_RATIO ? 'turn' : 'vertical';
    return vertical > turn ? 'vertical' : 'turn';
}
export function resolveXrTravelMultiplier(leftGrip, leftTrigger) {
    const pressure = applyDeadZone(Math.max(0, leftGrip));
    if (pressure <= 0)
        return 1;
    const slow = Math.max(0, applyDeadZone(leftTrigger));
    return slow > 0 ? XR_MIN_TRAVEL_MULTIPLIER ** slow : XR_MAX_TRAVEL_BOOST ** pressure;
}
export function resolveXrLocomotion(input, delta) {
    const dt = Math.min(Math.max(0, delta), XR_MAX_FRAME_DELTA);
    const multiplier = resolveXrTravelMultiplier(input.leftGrip, input.leftTrigger);
    const leftAxis = resolveXrLeftStickAxis(input.leftX, input.leftY, input.leftAxis);
    const x = applyDeadZone(input.rightX);
    const forward = -applyDeadZone(input.rightY);
    const vertical = leftAxis === 'vertical' ? -applyDeadZone(input.leftY) * XR_VERTICAL_SPEED_SCALE : 0;
    const magnitude = Math.hypot(x, forward, vertical);
    const length = Math.max(1, magnitude);
    const distance = XR_TRANSLATION_SPEED * multiplier * dt / length;
    return {
        x: x * distance,
        y: vertical * distance,
        forward: forward * distance,
        yaw: leftAxis === 'turn' ? -applyDeadZone(input.leftX)
            * Math.min(XR_MAX_ROTATION_SPEED, XR_ROTATION_SPEED * multiplier) * dt : 0,
        multiplier,
        throttle: magnitude / length,
        leftAxis,
    };
}
export function horizontalYaw(direction) {
    return direction.x * direction.x + direction.z * direction.z < 1e-8
        ? 0 : Math.atan2(-direction.x, -direction.z);
}
export function turnXrRig(rig, eye, angle, rotation) {
    rotation.setFromAxisAngle(THREE.Object3D.DEFAULT_UP, angle);
    rig.position.sub(eye).applyQuaternion(rotation).add(eye);
    rig.quaternion.premultiply(rotation);
    rig.updateMatrixWorld(true);
}
